import {InputAdornment} from '@mui/material'
import {FilterLiveSearch, FilterLiveSearchProps} from 'react-admin'

import {SearchIcon} from '../../components/icons'

const ExtendedFilterLiveSearch = ({
  slotProps, ...props
}: ExtendedFilterLiveSearchProps) => (
  <FilterLiveSearch
    alwaysOn
    slotProps={{
      ...slotProps,
      input: {
        endAdornment: (
          <InputAdornment position="end"><SearchIcon color="secondary" /></InputAdornment>
        ),
        onKeyDown: e => {
          if (e.key === 'Enter') {
            e.preventDefault()
            e.stopPropagation()
          }
        },
        ...slotProps?.input,
      },
    }}
    {...props}
  />
)

type ExtendedFilterLiveSearchProps = FilterLiveSearchProps

export default ExtendedFilterLiveSearch
